import { createRoute, useNavigate, useRouter } from '@tanstack/react-router'
import { useState } from 'react'
import { Mail, UserPlus } from 'lucide-react'
import rootRoute from './rootRoute'
import { Button, Input, errorToast, toast } from '@/components/ui'
import AuthLayout from '@/components/layout/AuthLayout'
import PasswordField from '@/components/PasswordField'
import { $client } from '@/lib/fetch'
import { validatePassword } from '@/lib/auth'

const SignupPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const router = useRouter()
  const navigate = useNavigate()

  const signup = async () => {
    if (password !== confirm) {
      toast({
        color: 'danger',
        title: 'Les mots de passe ne correspondent pas',
      })
      return
    }
    const err = validatePassword(password)
    if (err) {
      toast({ color: 'danger', title: err })
      return
    }

    setIsLoading(true)
    const resp = await $client
      .POST('/api/auth/signup', { body: { email, password } })
      .finally(() => setIsLoading(false))

    if (resp.error != null) {
      errorToast("Échec de l'inscription", resp.error)
    } else {
      toast({
        color: 'success',
        title: "Compte créé ! Vérifiez votre email pour l'activer.",
      })
      setTimeout(
        () => router.navigate({ to: '/login', search: { go: undefined } }),
        2000,
      )
    }
  }

  return (
    <AuthLayout
      panelTitle="Rejoignez la communauté"
      panelSub="Créez un compte pour proposer vos événements et rester connecté."
    >
      <h1 style={{ fontSize: 'var(--text-h2)', margin: '0 0 8px' }}>
        Créer un compte
      </h1>
      <p style={{ fontSize: 15.5, color: 'var(--ink-2)', marginBottom: 28 }}>
        Vous avez déjà un compte ?{' '}
        <a
          href="/login"
          onClick={(e) => {
            e.preventDefault()
            navigate({ to: '/login', search: { go: undefined } })
          }}
          style={{ color: 'var(--emerald-700)', fontWeight: 600 }}
        >
          Se connecter
        </a>
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          signup()
        }}
        style={{ display: 'flex', flexDirection: 'column', gap: 18 }}
      >
        <Input
          label="Adresse e-mail"
          type="email"
          iconLeft={<Mail size={18} />}
          placeholder="vous@email.fr"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <PasswordField
          label="Mot de passe"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <PasswordField
          label="Confirmer le mot de passe"
          placeholder="••••••••"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <Button
          variant="primary"
          size="lg"
          fullWidth
          type="submit"
          loading={isLoading}
          iconLeft={<UserPlus size={18} />}
        >
          Créer mon compte
        </Button>
      </form>
    </AuthLayout>
  )
}

export const signupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/signup',
}).lazy(() => import('./SignupPage.lazy').then((m) => m.Route))

export default SignupPage
